export default "__VITE_ASSET__5jwIU5_C__"